export { default as OpenShift } from './OpenShift';
